import { createWebHistory, createRouter } from "vue-router";
import Feed from "@/components/Feed/Feed.vue";
import Profile from "@/components/Profile/Profile.vue";
import PostModal from "@/components/Post/PostModal.vue";
import Login from "@/components/Login.vue";
import EditProfile from "@/components/Profile/EditProfile.vue";
import { useAuthStore } from "@/stores/authStore";
import { useModalStore } from "@/stores/modalStore";

const routes = [
  {
    path: "/",
    name: "Feed",
    component: Feed,
  },
  {
    path: "/post/:id",
    name: "Post",
    component: Feed,
    props: true,
    meta: { isModal: true },
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    meta: { requiresAuth: true },
  },
  {
    path: "/profile/edit",
    name: "EditProfile",
    component: EditProfile,
    meta: { requiresAuth: true },
  },
  {
    path: "/profile/:id",
    name: "UserProfile",
    props: true,
    component: Profile,
    meta: { requiresAuth: true },
    children: [
      {
        path: "post/:postId",
        name: "ProfilePost",
        component: PostModal,
        props: true,
        meta: { isModal: true },
      },
    ],
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: { isModal: true },
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.meta.isModal || from.meta.isModal) {
      return false;
    }

    if (savedPosition) {
      return savedPosition;
    }

    return { top: 0 };
  },
});

router.beforeEach((to, from) => {
  const auth = useAuthStore();
  const modal = useModalStore();

  if (to.meta.isModal && to.name === "Login") {
    modal.openModal({
      component: Login,
      options: { lockScroll: true },
    });
    return false;
  }

  if (to.meta.requiresAuth && !auth.isAuthenticated) {
    modal.openModal({
      component: Login,
      options: { lockScroll: true },
    });
    return false;
  }
});

export default router;
